import React from 'react';
import { Icon } from '@app/src/common/Icon';
import { Calendar } from '@app/src/common/datePicker/components/Calendar';
import { DateSelectedModel } from '@app/src/views/StepTwo/channelPublication';
import { CategoryModel } from '@app/src/views/Home/listProducts';
import {
  DateWrapper,
  DateSelected,
  IconWrapper,
  SubTitle,
  Separator
} from './styled';
import { COLORS } from '@app/src/ui';

interface Props {
  currentDateSelected?: DateSelectedModel[];
  categoryTheme?: CategoryModel;
  handleClickDeleteDay: Function;
  handleClickDay: Function;
  isDisabledRest?: boolean;
}

export const SectionDateSelected: React.FC<Props> = ({
  currentDateSelected,
  categoryTheme,
  handleClickDeleteDay,
  handleClickDay,
  isDisabledRest
}) => {
  return (
  <React.Fragment>
    <DateWrapper>
    {currentDateSelected && currentDateSelected.length > 0 && currentDateSelected.map((day, index) => (
      <DateSelected key={index}>
        <span>{day && day.fullDate}</span>
        <IconWrapper onClick={() => handleClickDeleteDay(day)}>
          <Icon
            data-name="icon-close-bold"
            width="11"
            height="11"
            fill={COLORS.RED_HIGHLIGHT}
          />
        </IconWrapper>
      </DateSelected>
    ))}
    </DateWrapper>
    <SubTitle>Seleccionar fecha de publicación</SubTitle>
    <Separator />
    <Calendar
      onClickDay={handleClickDay}
      dateSelected={currentDateSelected}
      categoryId={categoryTheme && categoryTheme.id}
      isDisabledRest={isDisabledRest}
    />
    <Separator />
  </React.Fragment>
)};